import React from "react";
import Slider from "react-input-slider";
import DropDown from "../../../components/DropDown";
import { inputTypes } from "../../../utils/tableData";
import CheckboxGroup from "../../../components/CheckBoxGroup";
import MultiSelectBtns from "../../../components/MultiSelectBtns";
import TextAreaInput from "../../../components/TextAreaInput";

const SurveyInputComp = ({ input, setFieldValue, value, values, title }) => {
  const getSliderStep = (value) => {
    if (value < 40) {
      return 0;
    } else if (value <= 55) {
      return 50;
    } else {
      return 100;
    }
  };

  return (
    <div className="mb-2 p-1 sm:p-2 flex items-center">
      {input.type == inputTypes.dropDown && (
        <>
          <MultiSelectBtns
            disabled={input.disabled}
            label={""}
            options={input.options.map((a) => ({
              label: a,
              value: a,
            }))}
            values={value ?? []}
            onChange={(e) => setFieldValue(input.name, e[0])}
            multiselect={input.multiselect}
          />
         
        </>
        // <DropDown
        //   options={input.options.map((a) => ({
        //     label: a,
        //     value: a
        //   }))}
        //   onChange={(e) => setFieldValue(input.name, e[0].value)}
        //   // onChange={(e) => console.log(input.name, e[0].value)}
        // />
      )}
      {input.type == inputTypes.slider && (
        <div className="pl-1 md:pl-0 flex items-center justify-center space-x-3">
          <p className="mr-4  text-xl text-gray-600 w-auto  md:w-28 text-center lg:text-right">
            {input.low ?? "Low"}
          </p>
          <div className="lg:pl-0 w-32 lg:w-[250px]">
            <Slider
              axis="x"
              x={value}
              onChange={({ x }) => setFieldValue(input.name, getSliderStep(x))}
              styles={{
                track: {
                  width: "100%",
                },
              }}
            />
          </div>
          <p className="text-xl text-gray-600 md:w-16 text-center">
            {input.high ?? "High"}
          </p>
        </div>
      )}
      {input.type == inputTypes.checkBoxGroup && (
        <MultiSelectBtns
          label={""}
          options={input.options.map((a) => ({
            label: a,
            value: a,
          }))}
          values={value ?? []}
          onChange={(e) => setFieldValue(input.name, e)}
          multiselect={input.multiselect}
        />
      )}
      {input.type == inputTypes.textArea && (
        <TextAreaInput
          label={input.label}
          value={value}
          onChange={(e) => setFieldValue(input.name, e.target.value)}
          containerStyle={input.containerStyle}
        />
      )}

      {input.type == inputTypes.textAreaGroup && (
        <div className="flex flex-col lg:flex-row gap-x-10">
          {input.textAreas.map((txtarea) => (
            <TextAreaInput
              label={txtarea.label}
              value={values[txtarea.name]}
              onChange={(e) => setFieldValue(txtarea.name, e.target.value)}
              containerStyle={input.containerStyle}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SurveyInputComp;
